<template>
    <common-panel
            v-model="value"
            :image="image"
            :is-read-only="readOnly"
            :width-style="widthStyle"
            :related-url="relatedUrl"
            :validation-lists="validationLists"
            :translate-obj="translateObj"
            :element-author-display="elementAuthorDisplay"
            @close="closePanel"
            @changeTranslate="changeTranslate"
    >

        <template slot="t-title-name">ReadModel</template>


        <template slot="t-description-text">
            행위와 결정을 하기 위하여 유저가 참고하는 데이터 (데이터 프로젝션이 필요 :  CQRS 등으로 수집)
        </template>

        <template slot="t-generation-text">
            Read Models become the implementation for data projection.
        </template>

        <template slot="t-edit-user">
            <div
                    v-if="newEditUserImg.length > 0 && readOnly"
                    style="text-align:center"
            >
                <v-chip
                        small
                        color="orange"
                        text-color="white"
                        style="font-weight:bold">
                    <v-avatar left>
                        <v-icon>mdi-lead-pencil</v-icon>
                    </v-avatar>
                    {{newEditUserImg[0].name}} is now editing...
                </v-chip>
            </div>
        </template>


        <template slot="element">
            <v-card flat>
                <v-card-text>
                    <event-storming-attribute
                            v-model="value.fieldDescriptors"
                            :isReadOnly="readOnly"
                            :type="value._type"
                            :elementId="value.elementView.id"
                    ></event-storming-attribute>
                </v-card-text>
            </v-card>

            <v-card flat>
                <v-card-text>
                    <v-radio-group :disabled="readOnly"
                                   v-model="value.dataProjection" row>
                        <v-radio :disabled="isOnlyCQRS" label="CQRS" value="cqrs"></v-radio>
                        <v-radio label="UI Mashup" value="uimashup"></v-radio>
                        <v-radio disabled label="GraphQL" value="graphql"></v-radio>
                    </v-radio-group>


                    <div v-if="value.dataProjection == 'cqrs'">
                        <v-col v-for="(item,key) in value.createRules">
                            <ViewCreate
                                    v-model="value"
                                    :createItem="item"
                                    :index="key"
                                    :isRead="readOnly"
                            ></ViewCreate>
                        </v-col>
                        <v-row align="start" justify="end">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="cqrs-add-btn" outlined :disabled="readOnly"
                                           @click="viewMainRowAdd('create')">
                                        <v-icon> mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add "CREATE" Card</span>
                            </v-tooltip>
                        </v-row>

                        <v-col v-for="(item,key) in value.updateRules">
                            <ViewUpdate
                                    v-model="value"
                                    :updateItem="item"
                                    :index="key"
                                    :isRead="readOnly"
                            >
                            </ViewUpdate>
                        </v-col>
                        <v-row align="center" justify="end">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="cqrs-add-btn" outlined :disabled="readOnly"
                                           @click="viewMainRowAdd('update')">
                                        <v-icon> mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add "UPDATE" Card</span>
                            </v-tooltip>
                        </v-row>

                        <v-col v-for="(item,key) in value.deleteRules">
                            <ViewDelete
                                    v-model="value"
                                    :deleteItem="item"
                                    :index="key"
                                    :isRead="readOnly"
                            ></ViewDelete>
                        </v-col>
                        <v-row align="start" justify="end">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="cqrs-add-btn" outlined :disabled="readOnly"
                                           @click="viewMainRowAdd('delete')">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add "DELETE" Card</span>
                            </v-tooltip>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </template>
    </common-panel>

</template>


<script>
    import CommonPanel from "./CommonPanel";
    import EventStormingModelPanel from "../EventStormingModelPanel";

    export default {
        mixins: [EventStormingModelPanel],
        name: 'view-panel',
        components: {
            CommonPanel
        },
        data() {
            return {}
        },
        computed: {
            isOnlyCQRS() {
                try {
                    var me = this
                    if (me.canvasbase.value && me.canvasbase.value.relations) {
                        var index = Object.values(me.canvasbase.value.relations).findIndex(relation => relation && relation._type.endsWith('Relation') && relation.from == me.value.elementView.id)
                        if (index == -1) {
                            return false
                        } else {
                            return true
                        }
                    }
                    return false
                } catch (e) {
                    return false
                }
            },

        },
        created: function () {
            this.panelInit()
        },
        methods: {
            panelInit(){
                var me = this
                // Command

                // Common
                me.$super(EventStormingModelPanel).panelInit()// }
            },
            viewMainRowAdd(type) {
                var me = this

                if (me.value.dataProjection == 'cqrs') {

                    if (type == 'create') {

                        var obj = {
                            _type: 'viewStoreRule',
                            operation: 'CREATE',
                            when: null,
                            fieldMapping: [{"viewField": null, "eventField": null, 'operator': '='}],
                            where: [{"viewField": null, "eventField": null}],
                        }

                        me.value.createRules.push(obj)
                    } else if (type == 'update') {
                        var obj = {
                            _type: 'viewStoreRule',
                            operation: 'UPDATE',
                            when: null,
                            fieldMapping: [{"viewField": null, "eventField": null, 'operator': '='}],
                            where: [{"viewField": null, "eventField": null}],
                        }
                        me.value.updateRules.push(obj)
                    } else if (type == 'delete') {
                        var obj = {
                            _type: 'viewStoreRule',
                            operation: 'DELETE',
                            when: null,
                            fieldMapping: [{"viewField": null, "eventField": null}],
                            where: [{"viewField": null, "eventField": null}],
                        }
                        me.value.deleteRules.push(obj)
                    }

                } else if (me.value.dataProjection == 'uimashup') {
                    // var ob = {
                    //     isKey: false,
                    //     name: '',
                    //     className: '',
                    //     sourceRepository: '',
                    //     repositoryDirectValue: '',
                    //     hateoas: '',
                    //     link: ''
                    // }
                    // me.value.viewFieldDescriptors.push(ob);
                }
            },
        }
    }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
    .cqrs-add-btn {
        margin:5px 30px 50px 0;
        color: #757575;
    }
</style>
